var _circle, _circle2, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFused(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    color: "currentColor",
    viewBox: "0 0 63.855 43.014",
    fill: "currentColor"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.142,
    cy: 21.507,
    r: 11.257,
    fill: "none",
    stroke: "#293846"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.992,
    cy: 21.507,
    r: 11.257,
    fill: "none",
    stroke: "#293846"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#293846",
    stroke: "#293846",
    d: "M47.059 11.384a11.257 11.257 0 00-.828.444l2.724.731a11.257 11.257 0 00-1.896-1.175zm-3.18 2.294a11.257 11.257 0 00-1.172 1.425l10.031 2.695a11.257 11.257 0 00-.915-1.986zm-2.347 3.59a11.257 11.257 0 00-.517 1.601l12.326 3.312a11.257 11.257 0 00.02-.689 11.257 11.257 0 00-.05-1.059zm-.831 3.999a11.257 11.257 0 00-.004.254 11.257 11.257 0 00.102 1.512l11.558 3.105a11.257 11.257 0 00.579-1.584zm.803 4.437a11.257 11.257 0 001.118 2.11l7.15 1.921a11.257 11.257 0 001.314-1.457zm4.894 5.607a11.257 11.257 0 00.603.318 11.257 11.257 0 00.205-.101z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#293846",
    color: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.046 10.918a10.918 10.918 0 01-10.918 10.918A10.918 10.918 0 013.21 10.918 10.918 10.918 0 0114.128 0a10.918 10.918 0 0110.918 10.918zM14.103 22.302c-7.793 0-14.13 5.736-14.111 12.767.001.488.043.93.107 1.344h-.107v6.598h28.223v-6.598h-.086c.053-.415.087-.856.086-1.344-.022-7.027-6.318-12.767-14.111-12.767z"
  }))));
}

export default SvgFused;